var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGroup53(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 102,
    height: 78,
    viewBox: "0 0 102 78",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-555 -5348)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(556.5 5349.5)"
  }, /*#__PURE__*/React.createElement("line", {
    x2: 10.769,
    transform: "translate(38.138 54.346)",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("line", {
    x2: 10.769,
    transform: "translate(59.677 54.346)",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.5 0.5)"
  }, /*#__PURE__*/React.createElement("line", {
    x2: 31.231,
    y2: 17.931,
    transform: "translate(9.1 23.854)",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 12.115,
    cy: 12.115,
    r: 12.115,
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("line", {
    y1: 35.108,
    x2: 60.9,
    transform: "translate(9.1 11.038)",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 12.115,
    cy: 12.115,
    r: 12.115,
    transform: "translate(0 45.769)",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M22.5,45A22.506,22.506,0,0,1,13.742,1.768,22.506,22.506,0,0,1,31.258,43.232,22.359,22.359,0,0,1,22.5,45ZM16.33,25.516a4.606,4.606,0,0,0,1.69,3.712,6.621,6.621,0,0,0,4.352,1.4A6.973,6.973,0,0,0,26.943,29.2a4.7,4.7,0,0,0,1.727-3.8,4.142,4.142,0,0,0-2.978-4.15,4.867,4.867,0,0,0,1.953-1.575,3.756,3.756,0,0,0,.744-2.246,4.622,4.622,0,0,0-1.6-3.717,6.677,6.677,0,0,0-4.419-1.349,7.041,7.041,0,0,0-2.973.623,5.025,5.025,0,0,0-2.1,1.727,4.362,4.362,0,0,0-.751,2.5h3.528a1.783,1.783,0,0,1,.683-1.446,2.616,2.616,0,0,1,1.7-.555,2.492,2.492,0,0,1,1.763.6,2.185,2.185,0,0,1,.642,1.673,2.473,2.473,0,0,1-.647,1.782,2.664,2.664,0,0,1-1.99.671h-1.88V22.7h1.868c1.944,0,2.93.9,2.93,2.661a2.307,2.307,0,0,1-.714,1.764,2.791,2.791,0,0,1-1.971.665,2.779,2.779,0,0,1-1.85-.635,2.053,2.053,0,0,1-.751-1.636Z",
    transform: "translate(612 5381)",
    fill: "#761ccb"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroup53);
export default __webpack_public_path__ + "static/media/Group53.9fd80c9b.svg";
export { ForwardRef as ReactComponent };